import React, { FC } from 'react'

const Privacy: FC = () => {
  return (
    <iframe
      scrolling="yes"
      title="Privacy Policy"
      src="https://www.iubenda.com/privacy-policy/60408354"
      allowFullScreen={true}
      className="w-full h-full min-w-full min-h-full"
    />
  )
}

export default Privacy
